module.exports = __webpack_public_path__ + "static/media/rhcsa-img-500x262.d941036b.png";